import { useDispatch, useSelector } from 'react-redux'
import BaseRadioButton from 'shared/components/base/form/base-radio-button'
import { setTransferredBusinessUnits } from 'store/slice/call-detail/call-detail.slice'
import { RootState } from 'store/store'

const TransferSubmissionForm = () => {
  const selectedValue = useSelector(
    (state: RootState) => state.callDetail.formData.transferredBusinessUnit
  )
  const dispatch = useDispatch()
  const businessUnits = [
    'تحویل کالا',
    'هیئت مدیره',
    'انبار آهن آنلاین',
    'طرح و برنامه ریزی',
    'روابط عمومی',
    'منابع انسانی ستادی',
    'شبکه و زیرساخت',
    'منابع انسانی بازرگانی',
    'آهن آنلاین پلاس',
    'انبار مالکان سرمایه',
    'مدیرعامل',
    'crm',
    'حسابداری',
  ]

  function handleCheck(bu: string) {
    dispatch(setTransferredBusinessUnits(bu))
  }

  return (
    <>
      <div className="mb-4 font-medium text-3.5 leading-[30px] text-[#0086B3]">
        بخش های سازمانی
      </div>
      <div className="grid grid-cols-2 items-center mb-0.5  ">
        {businessUnits.map((bu) => (
          <div
            className="flex items-center pl-4 mb-4 cursor-pointer"
            key={bu}
            onClick={() => handleCheck(bu)}
          >
            <BaseRadioButton className="ml-2" checked={bu === selectedValue} />
            <p className="inline text-sm font-normal leading-8 text-color-title">
              {bu}
            </p>
          </div>
        ))}
      </div>
    </>
  )
}

export default TransferSubmissionForm
